export default __webpack_public_path__ + "static/media/5.23f19c53.jpg";